import React, { FC } from 'react'
import css from './Copyright.module.scss'

const Copyright: FC = () => {
  const date = new Date()
  return <div className={css.container}>©{date.getFullYear()} KMcosmetics</div>
}

export default Copyright
